import 'velocity-animate/velocity.ui.min';

class TartoSetup {
    constructor() {
        if (window.tarteaucitron) {
            TartoSetup.init();
        }
    }

    static init() {
        const tacLink = document.querySelector('.js-open-tac');
        const cguPageUrl = document.body.getAttribute('data-tos-page');

        // Tarteaucitron init
        window.tarteaucitron.init({
            AcceptAllCta: true,
            adblocker: false,
            cookieName: 'tarteaucitron',
            cookieslist: true,
            handleBrowserDNTRequest: false,
            hashtag: '#tarteaucitron',
            highPrivacy: true,
            moreInfoLink: true,
            orientation: 'bottom',
            privacyUrl: cguPageUrl || '/cgu',
            removeCredit: true,
            showAlertSmall: false,
            useExternalCss: true,
            useExternalJs: false,
            showIcon: false,
        });

        window.dataLayer = window.dataLayer || [];

        // eslint-disable-next-line
        window.tarteaucitron.user.gtagUa = document.body.getAttribute('data-tac-ga');
        // eslint-disable-next-line
        (window.tarteaucitron.job = window.tarteaucitron.job || []).push('gtag');

        // Open TarteAuCitron on click.
        if (tacLink) {
            tacLink.addEventListener('click', (e) => {
                e.preventDefault();
                window.tarteaucitron.userInterface.openPanel();
            });
        }
    }
}

export default TartoSetup;
